/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Pauze_NaamInputs */

const nl_planning_rooster_pauze_naam = /** @type {(inputs: Planning_Rooster_Pauze_NaamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

/**

* @param {Planning_Rooster_Pauze_NaamInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_pauze_naam = /** @type {((inputs?: Planning_Rooster_Pauze_NaamInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Pauze_NaamInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_pauze_naam(inputs)
});
export { planning_rooster_pauze_naam as "planning.rooster.pauze.naam" }